<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_custname,pi_remark"
      placeholder="输入单据编号、客户、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/b2b/bill/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_custname}}</p>
          <p class="list-item-muted">{{item.pi_inoutno}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'"  v-if="!isFieldHidden('items.pi_total')">{{item.pi_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'"  v-if="!isFieldHidden('items.pi_total')">{{getTotal('pi_total')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import listCustomization from "@/mixins/listCustomization.js";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list,listCustomization],
  data() {
    return {
      listUrl: "/api/sale/prodinout/list",
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "currency",
          name: "pi_currency"
        }
      ],
      otherCondition: [{
        type: "condition",
        value: "((pi_class in ('SALEOUT','SALERETURN') and pi_status='已审核') or (pi_class='GOODSSEND')) and abs(round(ifnull(prodiodetail.pd_outqty,0)-ifnull(prodiodetail.pd_inqty,0),6))>abs(round(ifnull(prodiodetail.pd_billqty,0),6))"
      }],
      params: {
        mode: "DETAIL",
        caller: 'SaleOut',
        name: 'sale-saleout-querypanel-DETAIL', 
      }
    };
  }
};
</script>